import { Button } from "@op/sf-editor";
import { FeatherPlus } from "@subframe/core";
import { createFileRoute } from "@tanstack/react-router";
import { OrganizationCreateDialog } from "../../../components/app/admin/orgs/OrganizationCreateDialog";
import { useState } from "react";
import { Organization } from "../../../components/app/admin/orgs/Organization";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { adminRouterClient } from "../../../lib/adminRouterClient";

export const Route = createFileRoute("/admin/orgs/")({
  component: RouteComponent,
});

function RouteComponent() {
  const [createDialogOpen, setCreateDialogOpen] = useState<boolean>(false);

  const queryClient = useQueryClient();

  const { data: orgs } = useQuery(
    {
      queryKey: ["organizations"],
      queryFn: async () => {
        const res = await adminRouterClient.organizations.$get();
        return await res.json();
      },
    },
    queryClient
  );

  return (
    <>
      <div className="container max-w-none flex h-full w-full flex-col items-start gap-12 bg-default-background py-12">
        <div className="flex w-full flex-col items-start gap-6">
          <div className="flex w-full items-center gap-6 justify-between">
            <span className="whitespace-pre-wrap text-heading-1 font-heading-1 text-default-font">
              {"Organizations\n"}
            </span>
            <Button
              disabled={false}
              variant="brand-secondary"
              size="small"
              icon={null}
              iconRight={<FeatherPlus />}
              loading={false}
              onClick={() => setCreateDialogOpen(true)}
            >
              Add Organization
            </Button>
          </div>
          <div className="flex w-full flex-col items-start gap-12">
            {orgs?.map((org, index) => (
              <Organization
                key={org.slug}
                id={org.id}
                name={org.name}
                slug={org.slug}
                isLast={index === orgs.length - 1}
              />
            ))}
          </div>
        </div>
      </div>
      <OrganizationCreateDialog
        open={createDialogOpen}
        onOpenChange={setCreateDialogOpen}
      />
    </>
  );
}
